import React from "react";
import { ForgotPasswordForm } from "../../components/organizms/forgotPasswordForm";

export const ForgotPasswordPage = () => {
    return(
        <ForgotPasswordForm />
    )
}